import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, tap, withLatestFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DataService } from '../../services/data-api.service';
import { ApiService } from 'src/app/services/api.service';
import { Store } from '@ngrx/store';
//import { selectProjectSearchRequest } from './pricing-inputs.selector';
import {
  //loadAllActiveProjects,
  loadAllPricingInputsForSearchRequest,
  loadPricingInputsFailure,
  //loadPricingInputsSuccess,
  searchPricingInputsSuccess
} from './pricing-inputs.actions';
import { PricingInputRequest, PricingInputResponse } from 'src/app/models/pricing-view-models';
import { selectPricingInputRequest } from './pricing-inputs.selector';
//import { selectAllBrands } from '../brands';

/**
 * ProjectsEffects class is responsible for handling the side effects related to projects.
 * It contains methods to load active projects and search projects based on a request.
 */
@Injectable()
export class PricingInputsEffects {
  /**
   * Effect to load all pricing for search request - currently on by Product Model.
   * @returns An observable of actions.
   */
  loadAllPricingInputsForSearchRequest$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loadAllPricingInputsForSearchRequest),
        withLatestFrom(this.store.select(selectPricingInputRequest)),
        filter (([_, pricingInputRequest]) => pricingInputRequest?.ProductModelName !== null), // prevents running without product model
        exhaustMap(([_, pricingInputRequest]) => {
          //console.log('loadAllPricingInputsForSearchRequest$ is happening',pricingInputRequest);
          return this.apiService.post<PricingInputRequest, PricingInputResponse>('pricing/getpricinginputs', pricingInputRequest)
            .pipe(
                //tap(response => console.log('Search PricingInputs Response:', response)),
                map((pricingInputResponse) => {
                    //console.log('Search PricingInputs Response:', pricingInputResponse);
                    //response.Projects.forEach((project) => project.Brand = brands.find(brand => brand.BrandId === project.BrandId))
                    return searchPricingInputsSuccess({ pricingInputRequest, pricingInputResponse })
                  }
                ),
                catchError((error) =>
                  of(loadPricingInputsFailure({ error }))
                )
            );

        }
        )
      )
    }
  );

  constructor(private store: Store, private actions$: Actions, private dataService: DataService, private apiService: ApiService) {
  }
}
